import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// if ('serviceWorker' in navigator) {
//  window.addEventListener('load', () => {
//      navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/serviceWorker.js`)
//      .then(registration => {
//          console.log("Service worker registered",registration.scope);
//      })
//      .catch(error => {
//        console.log("Service worker registration FAILED", error);
//      });
//  });
// }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
